// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__13I1Q","content":"styles_content__3EqXY"};